import { Component, OnInit } from '@angular/core';
import { PostsService } from '../posts.service';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash';
import * as moment from 'moment';


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  public posts;
  public groups;
  public loading: boolean;

  constructor(private postService: PostsService, private titleService: Title) { }

  ngOnInit() {
    this.loading = true;
    this.titleService.setTitle("History -- Bender Hardware");

    this.postService.getHistoryList().then((_posts) => {
      let posts = _posts;
      this.loading = false;

      console.log("posts length : ", posts.length);

      posts = _.map(posts, (p) => {
        p.year = moment(p.data.history_date).format('YYYY');
        return p;
      });

      this.groups = _.map(_.groupBy(posts, 'year'), (val, key) => {
        return {
          year: key,
          posts: val
        };
      });
      console.log("this.groups: ", this.groups);

    }).catch((err) => {
      console.error(err);
      this.loading = false;

    });
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/history/history.component.ts